export default {
  IMAGE: 'image',
  VIDEO: 'video',
};
